// src/admin/AdminLogin.jsx
import React, { useState } from "react";
import axios from "axios";
import API_BASE_URL from "../config/apiConfig";

export default function AdminLogin({ onSuccess }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      const { data } = await axios.post(
        `${API_BASE_URL}/api/admin/auth/login`,
        {
          username,
          password,
        }
      );
      localStorage.setItem("adminToken", data.token);
      onSuccess();
    } catch {
      setErr("Invalid username or password");
    }
  };

  return (
    <div className="container py-5" style={{ maxWidth: "400px" }}>
      <h3 className="mb-3">Admin Login</h3>
      {err && <div className="alert alert-danger">{err}</div>}
      <form onSubmit={handleLogin}>
        <input
          type="text"
          className="form-control mb-2"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <input
          type="password"
          className="form-control mb-2"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button className="btn btn-dark w-100">Login</button>
      </form>
    </div>
  );
}
